import React from 'react';
import './ProfileCards.css';

const ProfileCards = () => {
  // Função para renderizar nome com quebras de linha
  const renderNameWithBreaks = (name) => {
    if (name.includes('<br/>')) {
      return name.split('<br/>').map((part, index, array) => (
        <React.Fragment key={index}>
          {part}
          {index < array.length - 1 && <br />}
        </React.Fragment>
      ));
    }
    return name;
  };

  // Dados dos perfis
  const profiles = [
    {
      id: 1,
      name: "Fábio <br/> Toniolo",
      role: "Professor",
      image: require("../../../assets/images/professores/fabio_toniolo.jpg"),
      backgroundColor: "#F5F5DC"
    },
    {
      id: 2,
      name: "Rejane Rocha",
      role: "Secretária Executiva",
      image: require("../../../assets/images/professores/rejane_rocha.jpg"),
      backgroundColor: "#FF6B35"
    },
    {
      id: 3,
      name: "João P. Bassin",
      role: "Professor Adjunto da UFRJ",
      image: require("../../../assets/images/professores/joao_paulo_bassin.jpg"),
      backgroundColor: "#8B5CF6"
    },
    {
      id: 4,
      name: "Argimiro R. Secchi",
      role: "Professor",
      image: require("../../../assets/images/professores/argimiro.png"),
      backgroundColor: "#8B5CF6"
    },
    {
      id: 5,
      name: "Márcio D'Agosto",
      role: "Doutorado",
      image: require("../../../assets/images/professores/marcio_dagosto.jpg"),
      backgroundColor: "#8B5CF6"
    }
  ];

  return (
    <div className="profile-cards-container">
      <div className="profile-cards-header">
        <h2 className="profile-cards-title">Professores e Participantes</h2>
      </div>
      
      <div className="profile-cards-grid">
        {profiles.map((profile) => (
          <div 
            key={profile.id} 
            className="profile-card"
          >
            <div className="profile-image-container">
              <img src={profile.image} alt={profile.name}
                className="profile-image"
              />
            </div>
            <div className="profile-info">
              <h3 className="profile-name">{renderNameWithBreaks(profile.name)}</h3>
              <p className="profile-role">{profile.role}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProfileCards;

